import { memo } from 'react';

/**
 * WelcomeNarrative - Hero section WITHOUT persona selector
 *
 * Per spec Phase 0.5: Persona selector moved to PromoDrawer.
 * This is the editorial greeting with calm positioning statement.
 */
function WelcomeNarrative({ title, subtitle, badge, compact = false }) {
  return (
    <section className={compact ? 'space-y-3 pt-1' : 'space-y-5 pt-2'}>
      <div className={compact ? 'space-y-1.5 text-center' : 'space-y-2 text-center'}>
        {badge && (
          <p className="text-[11px] font-medium tracking-[0.18em] text-slate-500 uppercase">
            {badge}
          </p>
        )}

        <h1
          className={
            compact
              ? 'text-[1.45rem] font-semibold leading-tight text-slate-900'
              : 'text-[1.75rem] font-semibold text-slate-900 sm:text-[1.9rem]'
          }
        >
          {title || 'What do you need help with today?'}
        </h1>

        {subtitle && (
          <p
            className={
              compact
                ? 'mx-auto max-w-[30rem] text-[15px] leading-7 text-slate-500'
                : 'mx-auto max-w-narrative text-sm leading-relaxed text-slate-500'
            }
          >
            {subtitle}
          </p>
        )}
      </div>
    </section>
  );
}

export default memo(WelcomeNarrative);
